var _g, _circle, _circle2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#1B2A4A",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 10 Q 32 46 55 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10 L 55 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 28 L 32 46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 46 L 40 46"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 20.5,
    r: 4.2,
    fill: "#E07A5F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 20.5,
    r: 4.2,
    fill: "#F4A261"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 28.3,
    y1: 20.5,
    x2: 35.7,
    y2: 20.5,
    stroke: "#1B2A4A",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ef128c03fd4d66babf093c375fc142c3.svg";
export { ForwardRef as ReactComponent };